import JSZip from 'jszip'

/** Plain text from a Word file. The live score stays beside this quote. */
export async function excerptFromDocx(buf: ArrayBuffer): Promise<string> {
  const zip = await JSZip.loadAsync(buf)
  const file = zip.file('word/document.xml')
  if (!file) return ''
  const xml = await file.async('string')
  const text = xml
    .replace(/<w:p\b[^>]*>/g, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line && !/^right\d+$/i.test(line))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
  return text.slice(0, 1400)
}
